/* eslint-disable import/no-anonymous-default-export */
import { AxiosError } from "axios";
import moment from "moment";
import { Tag } from "../../common/components/TagInput";
import useApi, { Model, Query } from "../../common/hooks/useApi"
import { error } from "console";


export interface CodigoInfraccion extends Model
{
    Abreviatura? : string
    Descripcion : string
    descripcion: string
    id: number
    Codigo : string
    Identificador?: string
    Articulo? : string
    Inciso?  : string
    //public decimal ValorUf { get;set; }
    SegmentosUf : {ValorUf?:number, LimiteMedicion?:number, LimiteFecha?:string, Provincia?: string, CodigoPostal?: string}[]
    //public decimal ValorUfReducido { get; set; }
    EtiquetasImagenes: Tag[]
    ValorUfMax : number
    ValorUfMin : number
    Categoria : string
    Observaciones? : string
    PuntosRestados? : number
    Etiqueta : string
}

export interface CodigoInfraccionForm extends Omit<CodigoInfraccion,'SegmentosUf'>
{
    SegmentosUf : {ValorUf?:number, LimiteMedicion?:number, LimiteFecha?:moment.Moment, Provincia?: string, CodigoPostal?: string}[]
}

export interface CodigoInfraccionSave extends Omit<CodigoInfraccion,'SegmentosUf' |'EtiquetasImagenes'>
{
    SegmentosUf : string
    EtiquetasImagenes:string
}


export const formatDescripcionCodigoInfraccion = (item: CodigoInfraccion): string => {
    const categoria = item.Categoria ?? (item as any).categoria;
    return categoria ? `${item.descripcion} -- ${categoria}` : item.descripcion;
}

const module = "CodigoInfraccion";

export default ()  => {
    const api = useApi({module});
    
    return {
        list:(query:Query)=>api.list!<CodigoInfraccion>(query),
        save:(data:Partial<CodigoInfraccionSave>)=>api.save!<Partial<CodigoInfraccionSave>,CodigoInfraccion>(data),
        delete:(id:number)=>api.delete(id),
        listEtiquetas: async () => {
            try {
                const response = await api.axiosInstance.get(`${module}/getEtiquetas`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        listCategorias: async () => {
            try {
                const response = await api.axiosInstance.get(`${module}/getCategorias`);
                return {
                    data: response.data
                };
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        codigoInfraccionPorUnidadProduccion: async (unidadProduccionId: number): Promise<{data:CodigoInfraccion[], error: AxiosError}> => {
            try {
                const response = await api.axiosInstance.get(`${module}/codigobyunidadproduccion/${unidadProduccionId}`);
                return {
                    data: response.data, 
                    error: null as any
                };
            } catch (error: any | AxiosError) {
                return {
                    data: null as any,
                    error
                };
            }
        },
    };
}